export enum NodeType {
  Interpolation = 'interpolation',
}
